import React, { useRef } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import Pane from 'components/Common/Pane'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'
import TextLink from 'components/Luxkit/TextLink'
import { useCruiseDeals } from 'hooks/Cruise/useCruiseDeals'
import DealsTile from 'components/Common/DealsTile/DealsTile'

const PageContent = styled.div`
  padding-top: ${rem(56)};

  ${mediaQueryUp.tablet} {
    padding-top: ${rem(80)};
  }
`

const DealsHeaderGrid = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr max-content;
  grid-gap: ${rem(12)};

  ${mediaQueryUp.tablet} {
    grid-gap: ${rem(16)};
  }
`

function CruisePageDealsTileCarousel() {
  const carouselRef = useRef<HTMLDivElement | null>(null)

  const { deals, isLoading } = useCruiseDeals()

  if (!isLoading && !deals.length) return null

  return <Pane>
    <PageContent>
      <Group gap={32} direction="vertical">
        <LayoutContainer>
          <DealsHeaderGrid>
            <Heading variant="heading2">
              Set sail with our hot cruise <i>promotions</i>
            </Heading>
            <TextLink size="medium" to="/search/cruises?isSpecialOffers=true&cabinTypes=Inside" weight="regular">View all</TextLink>
          </DealsHeaderGrid>
        </LayoutContainer>
        <DealsTile carouselRef={carouselRef} deals={deals} isLoading={isLoading} />
      </Group>
    </PageContent>
  </Pane>
}

export default CruisePageDealsTileCarousel
